import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const CrossIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 40 40" {...props}>
            <path d="M28 12L12 28" stroke="#2196F3" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M12 12L20 20L28 28"
                stroke="#2196F3"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
